export enum ConsentTypeId {
  hipaa = 1,
  program = 2,
  marketing = 3,
  texting = 4,
  voicemail = 5
}
